import { createContext } from 'react';

export const LoanTypeStoreContext = createContext(null);
